import { useForm } from "react-hook-form";

import { updateQuote } from "../../../api/quote/updateQuote";
import APTextField from "../../../components/form/APTextField";

type Inputs = {
  quoteName: string;
};

type QuoteComparisonNameProps = {
  id: string;
  dossierId: string;
  quoteComparisonIds: string[];
  name: string;
  isLocked: boolean;
};

const QuoteComparisonName = ({
  id,
  dossierId,
  quoteComparisonIds,
  name,
  isLocked,
}: QuoteComparisonNameProps) => {
  const { control } = useForm<Inputs>({ mode: "onTouched" });

  const { mutateAsync } = updateQuote(id);

  const handleBlur = (value: string) => {
    if (value !== name && !isLocked) {
      mutateAsync({ dossierId, name: value, quoteComparisonIds });
    }
  };

  return (
    <APTextField<Inputs>
      key={id}
      name="quoteName"
      label=""
      control={control}
      validations={{
        required: true,
        minLength: 1,
        maxLength: 100,
      }}
      errors={{}}
      defaultValue={name}
      readOnly={isLocked}
      readOnlyTextMode={true}
      onBlur={handleBlur}
      blurOnExit
      size="small"
      placeholder="Name this quote"
    />
  );
};

export default QuoteComparisonName;
